import { jsx as _jsx } from "react/jsx-runtime";
import InputField from "../form-fields/input";
import DropdownField from "../form-fields/dropdown";
import DateField from "../form-fields/date";
export var formFieldRenderer = function (fieldInfo, formik) {
    switch (fieldInfo.fieldType) {
        case "Text":
            return (_jsx(InputField, { fieldInfo: fieldInfo, formik: formik }, fieldInfo.name));
        case "Select":
            return _jsx(DropdownField, { fieldInfo: fieldInfo, formik: formik });
        case "Date":
            return _jsx(DateField, { fieldInfo: fieldInfo, formik: formik });
        default:
            return null;
    }
};
